import * as Yup from 'yup';

const schema = Yup.object().shape({
  email: Yup.string()
    .required('O campo deve ser preenchido')
    .email('Digite um email válido'),
});

export default schema;
